import React, { useEffect, useRef, useState } from "react";
import s from "./style.module.scss";
import { ISelectItem, SelectProps } from "./types";
import Arrow from "./icons/Arrow";

const Select: React.FC<SelectProps> = ({
  setValue,
  value,
  selectValues,
  label,
}) => {
  const selectRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleChange = (v: ISelectItem) => {
    setOpen(false);
    setValue(v);
  };

  const toggleOpen = () => setOpen(!open);

  useEffect(() => {
    if (selectRef.current) {
      const closeMenu = (e: React.MouseEvent<HTMLElement>) => {
        //@ts-ignore
        if (!selectRef.current?.contains(e.target)) {
          setOpen(false);
        }
      };

      //@ts-ignore
      document?.body.addEventListener("click", closeMenu);
      //@ts-ignore
      return () => document?.body.removeEventListener("click", closeMenu);
    }
  }, [selectRef]);

  return (
    <div ref={selectRef} className={s.select}>
      <div className={s.header} onClick={toggleOpen}>
        <span className={s.label}>{label}</span>

        <span className={s.value}>
          {value?.title} <Arrow />
        </span>
      </div>

      <ul className={`${s.list} ${open ? s.open : ""}`}>
        {selectValues.map((item) => (
          <li key={item.id} onClick={() => handleChange(item)}>
            {item.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Select;
